import PortForm from './PortForm';
import Ports from './Ports';

const PortsConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/ports',
      element: <Ports />,
    },
    {
      path: '/addPort',
      element: <PortForm />,
    },
    {
      path: '/editPort/:id',
      element: <PortForm />,
    },
  ],
};

export default PortsConfig;
